import MainLayout from "../layouts/MainLayout";
import * as React from "react";
import * as ReactDOM from "react-dom/client";


import {
    createBrowserRouter

} from "react-router-dom";

import {
    Landing,
    Login,

    PasswordChange,


    About,

    Certificates, Parcellist
} from '../pages'
import Details from "../pages/Parceldetails";
import Parcellogs from "../pages/Parcellogs";
import ParcellistCitybased from "../pages/ParcellistCitybased";
import Parcelsliststatus from "../pages/Parcelstatusbased";



export const router = createBrowserRouter([
    {
        path: '/admin',
        element: <MainLayout/>,

        children: [

            {
                path: '/admin',
                element: <Landing/>
            },




            {
                path: '/admin/password-change',
                element: <PasswordChange/>
            },

            {
                path: '/admin/about',
                element: <About/>
            }
            ,
            {
                path: '/admin/centers',
                element: <Certificates/>
            },
            {
                path: '/admin/parcels',
                element: <Parcellist/>
            }
            ,
            {
                path: '/admin/parcels-city',
                element: <ParcellistCitybased/>
            }
            ,
            {
                path: '/admin/parcels-status',
                element: <Parcelsliststatus/>
            }








        ]


    },
    {
        path:'/parcel/:id',
        element:<Details/>
    },
    {
        path:'/parcel/logs/:id',
        element: <Parcellogs/>
    },

    {
        path: '/',
        element: <Login/>
    }

])